
const theme = {
  global: {
    color: '#1F3E74',
  },
  button: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#fff',
    borderRadius: '22.5px',
    background: 'linear-gradient(#f76100,#e85b00,#de5700)',
    height: '37px',
    width: '100%',
    border: '1px solid transparent',
    cursor: 'pointer',
    hover: {
      background: 'linear-gradient(#de5700,#e85b00,#f76100);',
    },
  },
  text: {
    color: '#414c58',
    subtitle: '#2D363E',
  },
  box: {
    border: '1px solid #ccc',
    borderRadius: '3px',
    baseGlowingColor: '#0F3485',
    errorGlowingColor: '#E14545',
    height: '40px',
    lineHeight: '20px',
  },
};

export default theme;
